export const INSERT_CTC_LEVEL_MUTATION = `
  mutation InsertCtcLevel($input: CtcLevelInsertInput!) {
    insertCtcLevel(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_CTC_LEVEL_MUTATION = `
  mutation UpdateCtcLevel($filter: String!, $input: CtcLevelUpdateInput!) {
    updateCtcLevel(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_CTC_LEVEL_MUTATION = `
  mutation DeleteCtcLevel($filter: String!, $input: CtcLevelDeleteInput!) {
    deleteCtcLevel(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
